import { Box, Flex, Badge, Divider, Text, Grid } from "@mantine/core";
import { green } from "../../const/variables";

const ExportAmortization = ({
  data,
  code,
  typeInstallment,
}: {
  data: string;
  code: string;
  typeInstallment: number;
}) => {
  const dataView = JSON.parse(data);

  return (
    <Box m={15} w={typeInstallment === 1 ? 250 : 275}>
      <Flex justify={"center"} w={"100%"}>
        <Badge color={green.base} radius="sm" variant="dot" size="lg">
          {code}
        </Badge>
      </Flex>
      <Divider label="Thông tin trả góp" labelPosition="center" my={"xs"} />
      <Flex align={"center"} gap={"md"} w={"100%"}>
        {typeInstallment === 1 ? (
          <>
            <Flex direction={"column"} gap={"xs"} w={"100%"}>
              <Grid w={"100%"}>
                <Grid.Col span={{ base: 12, md: 12, lg: 7 }}>
                  <Text size="md" fw={500}>
                    Ngân hàng:
                  </Text>
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 12, lg: 5 }}>
                  <Text size="md">
                    {dataView?.selectedBankCode
                      ? dataView?.selectedBankCode
                      : "Không có dữ liệu !"}
                  </Text>
                </Grid.Col>
              </Grid>
              <Grid w={"100%"}>
                <Grid.Col span={{ base: 12, md: 12, lg: 7 }}>
                  <Text size="md" fw={500}>
                    Loại thẻ:
                  </Text>
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 12, lg: 5 }}>
                  <Text size="md">
                    {dataView?.selectedCard
                      ? dataView?.selectedCard
                      : "Không có dữ liệu !"}
                  </Text>
                </Grid.Col>
              </Grid>
              <Grid w={"100%"}>
                <Grid.Col span={{ base: 12, md: 12, lg: 7 }}>
                  <Text size="md" fw={500}>
                    Trả góp mỗi tháng:
                  </Text>
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 12, lg: 5 }}>
                  <Text size="md">
                    {dataView?.monthlyPayment
                      ? `${Number(
                          dataView?.monthlyPayment
                        )?.toLocaleString()} đ`
                      : "Không có dữ liệu !"}
                  </Text>
                </Grid.Col>
              </Grid>
              <Grid w={"100%"}>
                <Grid.Col span={{ base: 12, md: 12, lg: 7 }}>
                  <Text size="md" fw={500}>
                    Số tháng trả góp:
                  </Text>
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 12, lg: 5 }}>
                  <Text size="md">
                    {dataView?.month
                      ? `${dataView?.month} tháng`
                      : "Không có dữ liệu !"}
                  </Text>
                </Grid.Col>
              </Grid>
              <Grid w={"100%"}>
                <Grid.Col span={{ base: 12, md: 12, lg: 7 }}>
                  <Text size="md" fw={500}>
                    Tổng tiền trả góp:
                  </Text>
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 12, lg: 5 }}>
                  <Text size="md">
                    {dataView?.installmentAmount
                      ? `${Number(
                          dataView?.installmentAmount
                        )?.toLocaleString()} đ`
                      : "Không có dữ liệu !"}
                  </Text>
                </Grid.Col>
              </Grid>
            </Flex>
          </>
        ) : (
          <>
            <Flex direction={"column"} gap={"xs"} w={"100%"}>
              <Grid w={"100%"}>
                <Grid.Col span={{ base: 12, md: 12, lg: 6.5 }}>
                  <Text size="md" fw={500}>
                    Công ty tài chính:
                  </Text>
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 12, lg: 5.5 }}>
                  {" "}
                  <Text size="md">
                    {dataView?.selectedCompany
                      ? `${dataView?.selectedCompany}`
                      : "Không có dữ liệu !"}
                  </Text>
                </Grid.Col>
              </Grid>
              <Grid w={"100%"}>
                <Grid.Col span={{ base: 12, md: 12, lg: 6.5 }}>
                  <Text size="md" fw={500}>
                    Tiền trả trước:
                  </Text>
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 12, lg: 5.5 }}>
                  <Text size="md">
                    {dataView?.prepay
                      ? `${Number(dataView?.prepay)?.toLocaleString()} đ`
                      : "Không có dữ liệu !"}
                  </Text>
                </Grid.Col>
              </Grid>
              <Grid w={"100%"}>
                <Grid.Col span={{ base: 12, md: 12, lg: 6.5 }}>
                  <Text size="md" fw={500}>
                    Lãi suất (%):
                  </Text>
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 12, lg: 5.5 }}>
                  <Text size="md">
                    {dataView?.interestRate
                      ? `${Number(dataView?.interestRate) * 100} %`
                      : "Không có dữ liệu !"}
                  </Text>
                </Grid.Col>
              </Grid>
              <Grid w={"100%"}>
                <Grid.Col span={{ base: 12, md: 12, lg: 6.5 }}>
                  <Text size="md" fw={500}>
                    Tổng tiền đơn hàng:
                  </Text>
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 12, lg: 5.5 }}>
                  <Text size="md">
                    {dataView?.totalAmountPayable
                      ? `${Number(
                          dataView?.totalAmountPayable
                        )?.toLocaleString()} đ`
                      : "Không có dữ liệu !"}
                  </Text>
                </Grid.Col>
              </Grid>
              <Grid w={"100%"}>
                <Grid.Col span={{ base: 12, md: 12, lg: 6.5 }}>
                  <Text size="md" fw={500}>
                    Trả góp mỗi tháng:
                  </Text>
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 12, lg: 5.5 }}>
                  <Text size="md">
                    {dataView?.monthlyPaymentHD
                      ? `${Number(
                          dataView?.monthlyPaymentHD
                        )?.toLocaleString()} đ`
                      : "Không có dữ liệu !"}
                  </Text>
                </Grid.Col>
              </Grid>
              <Grid w={"100%"}>
                <Grid.Col span={{ base: 12, md: 12, lg: 6.5 }}>
                  <Text size="md" fw={500}>
                    Số tháng trả góp:
                  </Text>
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 12, lg: 5.5 }}>
                  <Text size="md">
                    {dataView?.selectedMonth
                      ? `${dataView?.selectedMonth} tháng`
                      : "Không có dữ liệu !"}
                  </Text>
                </Grid.Col>
              </Grid>
              <Grid w={"100%"}>
                <Grid.Col span={{ base: 12, md: 12, lg: 6.5 }}>
                  <Text size="md" fw={500}>
                    CMND/CCCD:
                  </Text>
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 12, lg: 5.5 }}>
                  <Text size="md">
                    {dataView?.cmnd
                      ? `${dataView?.cmnd}`
                      : "Không có dữ liệu !"}
                  </Text>
                </Grid.Col>
              </Grid>
              <Grid w={"100%"}>
                <Grid.Col span={{ base: 12, md: 12, lg: 6.5 }}>
                  <Text size="md" fw={500}>
                    Ngày cấp căn cước:
                  </Text>
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 12, lg: 5.5 }}>
                  <Text size="md">
                    {dataView?.dob ? `${dataView?.dob}` : "Không có dữ liệu !"}
                  </Text>
                </Grid.Col>
              </Grid>
            </Flex>
          </>
        )}
      </Flex>
    </Box>
  );
};

export default ExportAmortization;
